(function () {
  // The cart drawer is (re)rendered by JS after page load, so this must NOT depend on DOMContentLoaded
  // or on elements existing at load time. Everything is looked up lazily and (re)bound on demand.
  if (window.__lovyGiftDate) return;
  window.__lovyGiftDate = true;

  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const DAYS = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  const $ = (id) => document.getElementById(id);

  function toYMD(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function fromYMD(ymd) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  }
  function getTomorrow() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const tomorrow = getTomorrow();
  let viewYear = tomorrow.getFullYear();
  let viewMonth = tomorrow.getMonth();
  let selectedYMD = null;
  let loadedFromCart = false;

  function showSelected() {
    const label = $('gift-date-selected-label');
    const input = $('gift_date');
    if (input) input.value = selectedYMD || '';
    if (!label) return;
    const d = fromYMD(selectedYMD);
    if (d) {
      label.textContent = '📦 Delivery: ' + d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      label.style.color = '#2e7d32';
    } else {
      label.textContent = '';
    }
  }

  function saveDate(ymd, previous) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery date': ymd } }),
      keepalive: true
    }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    }).catch(function (err) {
      console.error('[gift-date] could not save delivery date', err);
      selectedYMD = previous;
      showSelected();
      render();
    });
  }

  function bindOnce() {
    const picker = $('gift-date-picker');
    if (!picker || picker.dataset.lovyBound === '1') return;
    picker.dataset.lovyBound = '1';

    // Keep clicks inside the calendar from closing the cart drawer.
    picker.addEventListener('click', function (e) { e.stopPropagation(); });
    picker.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    picker.addEventListener('touchend', function (e) { e.stopPropagation(); });

    $('gift-date-prev').addEventListener('click', function (e) {
      e.preventDefault();
      if (e.currentTarget.disabled) return;
      viewMonth--;
      if (viewMonth < 0) { viewMonth = 11; viewYear--; }
      render();
    });
    $('gift-date-next').addEventListener('click', function (e) {
      e.preventDefault();
      viewMonth++;
      if (viewMonth > 11) { viewMonth = 0; viewYear++; }
      render();
    });
  }

  function render() {
    const grid = $('gift-date-grid');
    const monthLabel = $('gift-date-month-label');
    const prevBtn = $('gift-date-prev');
    if (!grid || !monthLabel) return;
    bindOnce();

    monthLabel.textContent = MONTHS[viewMonth] + ' ' + viewYear;
    grid.innerHTML = '';

    DAYS.forEach(function (d) {
      const cell = document.createElement('div');
      cell.textContent = d;
      cell.style.cssText = 'font-weight:600;padding:4px 0;color:#888;font-size:0.7rem;';
      grid.appendChild(cell);
    });

    const firstDay = new Date(viewYear, viewMonth, 1).getDay();
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    for (let i = 0; i < firstDay; i++) grid.appendChild(document.createElement('div'));

    for (let day = 1; day <= daysInMonth; day++) {
      const cell = document.createElement('div');
      const thisDate = new Date(viewYear, viewMonth, day);
      const ymd = toYMD(thisDate);
      const isPast = thisDate < tomorrow;
      const isSelected = ymd === selectedYMD;

      cell.textContent = day;
      cell.style.cssText =
        'padding:6px 2px;border-radius:50%;transition:background 0.15s;' +
        'cursor:' + (isPast ? 'default' : 'pointer') + ';' +
        'background:' + (isSelected ? '#000' : 'transparent') + ';' +
        'color:' + (isSelected ? '#fff' : isPast ? '#ccc' : '#000') + ';' +
        'font-weight:' + (isSelected ? '600' : 'normal') + ';';

      if (!isPast) {
        cell.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          const previous = selectedYMD;
          selectedYMD = ymd;
          showSelected();
          saveDate(ymd, previous);
          render();
        });
        cell.addEventListener('mouseenter', function () { if (ymd !== selectedYMD) cell.style.background = '#f0f0f0'; });
        cell.addEventListener('mouseleave', function () { if (ymd !== selectedYMD) cell.style.background = 'transparent'; });
      }
      grid.appendChild(cell);
    }

    if (prevBtn) {
      const now = new Date();
      prevBtn.disabled = (viewYear === now.getFullYear() && viewMonth <= now.getMonth());
      prevBtn.style.opacity = prevBtn.disabled ? '0.3' : '1';
      prevBtn.style.cursor = prevBtn.disabled ? 'default' : 'pointer';
    }
    showSelected();
  }

  // Restore a previously chosen date from the server cart (once per page).
  function loadFromCart() {
    if (loadedFromCart) return;
    loadedFromCart = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const saved = cart && cart.attributes && cart.attributes['Delivery date'];
        const d = fromYMD(saved);
        if (d && d >= tomorrow && !selectedYMD) {
          selectedYMD = saved;
          viewYear = d.getFullYear();
          viewMonth = d.getMonth();
          render();
        }
      })
      .catch(function () {});
  }

  function ensure() {
    const grid = $('gift-date-grid');
    if (!grid) return;
    if (grid.children.length === 0) render();
    loadFromCart();
  }

  // Accordion opened (toggle does not bubble, so listen in the capture phase).
  document.addEventListener('toggle', function (e) {
    const t = e.target;
    if (t instanceof Element && t.matches('.cart-gift-date details') && t.open) { render(); loadFromCart(); }
  }, true);

  // Drawer/summary (re)rendered by JS: render whenever the grid shows up empty.
  let scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; ensure(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  ensure();
})();
